export type InquiryStatus = 'PENDING' | 'IN_PROGRESS' | 'ANSWERED' | 'CLOSED';
export type InquiryCategory = 'ACCOUNT' | 'PAYMENT' | 'TECHNICAL' | 'FEATURE_REQUEST' | 'BUG_REPORT' | 'CONTENT' | 'OTHER';

export const STATUS_LABELS: Record<InquiryStatus, string> = {
    PENDING: '답변 대기',
    IN_PROGRESS: '답변 작성중',
    ANSWERED: '답변 완료',
    CLOSED: '종료',
};

export const STATUS_COLORS: Record<InquiryStatus, 'warning' | 'info' | 'success' | 'default'> = {
    PENDING: 'warning',
    IN_PROGRESS: 'info',
    ANSWERED: 'success',
    CLOSED: 'default',
};

export const CATEGORY_LABELS: Record<InquiryCategory, string> = {
    ACCOUNT: '계정 문의',
    PAYMENT: '결제 문의',
    TECHNICAL: '기술 지원',
    FEATURE_REQUEST: '기능 제안',
    BUG_REPORT: '버그 신고',
    CONTENT: '콘텐츠 문의',
    OTHER: '기타',
};

export interface InquiryItem {
    id: number;
    userId: number;
    userEmail?: string;
    userNickname?: string;
    category: InquiryCategory;
    categoryDescription: string;
    title: string;
    status: InquiryStatus;
    statusDescription: string;
    hasAnswer: boolean;
    isRead: boolean;
    appVersion?: string;
    createdAt: string;
    updatedAt: string;
}

export interface InquiryDetail {
    id: number;
    userId: number;
    userEmail?: string;
    userNickname?: string;
    category: InquiryCategory;
    categoryDescription: string;
    title: string;
    content: string;
    status: InquiryStatus;
    statusDescription: string;
    answer?: string;
    answeredAt?: string;
    isRead: boolean;
    appVersion?: string;
    createdAt: string;
    updatedAt: string;
}

export interface InquirySummary {
    pendingCount: number;
    inProgressCount: number;
    answeredCount: number;
    closedCount: number;
}

export interface InquiryFilterParams {
    page: number;
    size: number;
    status?: InquiryStatus;
    category?: InquiryCategory;
    keyword?: string;
}
